export const CHOKEPOINTS = {
  FLIGHTS_BOOKING_PANEL_WITH_TURK_DEAL: 'flights_booking_panel_with_turk_deal',
  BANANA_RAIL_HAS_RESULTS: 'banana_rail_has_results',
  USERS_WHO_SAW_COMBINED_EXPLORE: 'banana_users_who_saw_combined_explore',
  USERS_WHO_SAW_COMBINED_EXPLORE_WITH_NO_FLIGHTS:
    'banana_users_who_saw_combined_explore_with_no_flight_results',
  USERS_WHO_SAW_COMBINED_RESULTS_WITH_NO_FLIGHTS: 'banana_FlightsDayViewNoResults',
  USERS_WHO_SAW_COMBINED_RESULTS: 'combined_results_search_start',
  FLIGHT_BOOKING_PANEL_PQS_SURVEY_POPPED_UP: 'flight_booking_panel_pqs_survey_popped_up',
  FLIGHTS_SEARCH_INITIAL_LOAD: 'flights_search_initial_load',
  FLIGHTS_RESULTS_RENDERED: 'flights_results_rendered',
  USER_RUNS_DEFINED_SEARCH: 'user_runs_defined_search',
  USERS_WHO_SAW_EXPLORE_ON_MWEB_OR_DESKTOP: 'banana_users_who_saw_explore_on_mweb_desktop',
  USERS_LAND_ON_SPAIN_OR_ITALY_RESULTS: 'banana_users_land_on_spain_or_italy_results',
  USERS_WHO_SAW_EXPLORE_EVERYWHERE_OR_COUNTRY_DESTINATION:
    'banana_everywhere_or_country_destination',
  USERS_WHO_SAW_EXPLORE_EVERYWHERE_OR_COUNTRY_DESTINATION_ON_MWEB:
    'banana_everywhere_or_country_destination_on_mweb',
  CE_COUNTRY_VIEW_PAGE: 'ce_country_view_page',
  CE_ELIGIBLE_FOR_DEAL_BADGE: 'explore_eligible_for_deal_badge',
  USERS_WHO_SAW_NL_SEARCH_BUTTON: 'banana_users_who_saw_nl_search_button',
  USERS_WHO_SAW_POSITION_5_OR_6: 'users_who_saw_position_5_or_6',
  USERS_WHO_RAN_EXPLORE_AI_SEARCH: 'users_who_ran_explore_ai_search',
  USERS_ELIGIBLE_FOR_EXPLORE_EVENTS: 'users_eligible_for_explore_events',
  USERS_WHO_SAW_CITY_DRAWER: 'banana_users_who_saw_city_drawer',
  EXPLORE_USER_ELIGIBLE_FOR_SPONSORED_AIRLINE_BANNER:
    'explore_user_eligible_for_sponsored_airline_banner',
  PRICE_PULSE_SHOWN: 'price_pulse_shown',
} as const;
